@if (users()) {
  <p-table #usersTable [columns]="columns" [value]="users() ?? []" class="p-3 tableHeaderAlignTop transparent">
    <ng-template #caption>
      <div class="flex justify-content-end align-items-center gap-2">
        <app-svg-icon
          id="addUserButton"
          *appHasPermission="{
            permissions: [permissions.allPermissions.USER_CREATE],
          }"
          class="pointer"
          iconName="plus"
          iconColor="primary"
          (click)="onCreateClick()"
        >
        </app-svg-icon>
      </div>
    </ng-template>
    <ng-template #header let-columns>
      <tr>
        @for (col of columns; track col) {
          <th>
            {{ col.header | translate }}
          </th>
        }
        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-rowData let-columns="columns">
      <tr>
        @for (col of columns; track col) {
          <td>
            {{ rowData[col.field] | translate }}
          </td>
        }
        <td class="flex gap-4 justify-content-end">
          <app-svg-icon
            [id]="'editUserButton' + rowData?.id"
            *appHasPermission="{
              permissions: [permissions.allPermissions.USER_UPDATE],
            }"
            class="pointer"
            iconName="edit"
            iconColor="primary"
            (click)="onEditClick(rowData)"
          ></app-svg-icon>
          <app-svg-icon
            [id]="'deleteUserButton' + rowData?.id"
            *appHasPermission="{
              permissions: [permissions.allPermissions.USER_DELETE],
            }"
            class="pointer"
            iconName="trash"
            iconColor="primary"
            (click)="onDeleteClick(rowData, $event)"
          ></app-svg-icon>
        </td>
      </tr>
    </ng-template>
  </p-table>
}
